export default __webpack_public_path__ + "static/media/onerror.1362bf9c.png";